<template>
    <MescrollVue :id="id" ref="mescroll" :up="mescrollUp" class="mescroll" @init="mescrollInit">
      <slot></slot>
    </MescrollVue>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  name: "mdScroll",
  props: {
    url: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: 'mescroll'
    },
    filterData: {
      type: Object,
      default: () => {
        return {
          PageIndex: 1,
          PageSize: 10
        }
      }
    },
    fetchList: Function,
    listAlias: {
      type: String,
      default: 'List'
    }
  },
  components: { MescrollVue },
  data() {
    return {
      list: [],
      mescrollUp: {
        // isBounce: false,在iOS的微信,QQ,Safari等浏览器, 列表顶部下拉和底部上拉露出浏览器灰色背景, 卡顿2秒
        callback: this.onMescrollUp,
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 //每页数据条数,默认10
        }
      },
      mescroll: null
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          let that = this
          let el = document.querySelector(`#${this.id}`)
          el && el.addEventListener('scroll', function () {
            let fullPath = that.$route.fullPath
            let top = this.scrollTop
            let data = {
              [fullPath]: {
                top,
                dom: `#${this.id}`
              }
            }
            that.$route.meta.more = Object.assign({}, that.$route.meta.more ? that.$route.meta.more : {}, data)
          })
        })
      }
    }
  },
  methods: {
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    async getList() {
      try {
        let result = await this.$api(this.url, this.filterData, false, false)
        let TotalRecord = result.TotalRecord || result.Total || 0
        let List = []
        if (this.listAlias) {
          List = result[this.listAlias] || []
        } else {
          List = result.List || []
        }
        
        if (this.filterData.PageIndex === 1) this.list = []
        this.fetchList && await this.fetchList(List)
        this.list = this.list.concat(List)
        this.$emit('getList', this.list, List)
        this.$emit('getResult', result)
        
        this.TotalRecord = TotalRecord
        this.$nextTick(() => {
          this.mescroll.endBySize(List.length, TotalRecord)
        })
      } catch (error) {
        this.mescroll.endErr()
      }
    },
    onMescrollUp(data) {
      this.filterData.PageIndex = data.num
      this.filterData.PageSize = data.size
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.hasBottom {
  bottom: 40px !important;
}
.mescroll {
  position: fixed;
  top: 90px;
  bottom: 0px;
  left: 0;
  height: auto;
  width: 100%;
}
</style>

